// Bio Image imports

import NTUlogo from "../images/NTU_logo.jpg";
import Jaya from "../images/jaya Mv.jpeg";
import Gmmv from "../images/gmmv.jpg";

// SKills Image imports

import Tailwind from "../images/tailwind.png";
import Dart from "../images/dart.png";
import Php from "../images/php.png";
import Git from "../images/git.png";
import Visly from "../images/visly.png";
import Postman from "../images/postman.png";
import Figma from "../images/figma.png";
import Wordpress from "../images/wordpress.png";

// Experince Image imports

import Prodigi from "../images/prodigi.jpeg";
import Eyesome from "../images/eyesome.jpeg";
import EysomeExp from "../images/eyesomeExp.png";
import ProdigiExp from "../images/prodigiExp.png";
import XploritExp from "../images/Xplorit Certification.jpeg";

//project Image Imports

import Wp1 from "../images/wp1.png";
import Wp2 from "../images/wp2.png";
import Wp3 from "../images/wp3.png";
import Wp4 from "../images/wp4.png";
import Js1 from "../images/js1.png";
import Js2 from "../images/js2.png";
import Js3 from "../images/js3.png";
import Js4 from "../images/js4.png";
import Js5 from "../images/js5.png";
import Js6 from "../images/js6.png";
import Js7 from "../images/js7.png";
import Js8 from "../images/js8.png";

import Rj1 from "../images/rj1.png";
import Rj2 from "../images/rj2.png";
import Rj3 from "../images/rj3.png";
import Rj4 from "../images/rj4.png";

import Mn1 from "../images/mn1.png";
import Mn2 from "../images/mn2.png";
import Mn3 from "../images/w2p.png";


import Fl1 from "../images/Xp A4.png";
// Personsl Bio
export const Bio = {
  name: "Abdul Azees",
  roles: ["Full Stack Developer", "Flutter Developer"],
  description:
    "I'm an enthusiastic and adaptable professional with a strong commitment to excellence. I thrive on learning and embrace challenges with a proactive approach. My dedication to delivering outstanding results, coupled with a positive outlook, empowers me to contribute effectively and achieve impactful outcomes.",
  github: "https://github.com/mkabdulazees56",
  resume:
    "https://drive.google.com/file/d/1tSPy28M0ggoYloZ5ry9e2sVXQ4rgC1BB/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/mk-abdul-azees/",
  twitter: "https://twitter.com/MkAbdulAzees56/",
  insta:
    "https://www.instagram.com/mk_abdul_azees?igsh=MWY4cnFyM29idWtmdQ%3D%3D&utm_source=qr",
  facebook:
    "https://www.facebook.com/profile.php?id=100009822756068&mibextid=LQQJ4d",
};

//Skills

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Tailwind CSS",
        image: Tailwind,
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "WordPress",
        image: Wordpress,
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Flutter",
        image:
          "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Php",
        image: Php,
      },

      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "Android",
    skills: [
      {
        name: "Kotlin",
        image:
          "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
      },
      {
        name: "XML",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
      },
      {
        name: "Dart",
        image: Dart,
      },
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image: Git,
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image: Postman,
      },
      {
        name: "Visly",
        image: Visly,
      },
      {
        name: "Figma",
        image: Figma,
      },
    ],
  },
];

//Experience

export const experiences = [
  {
    id: 0,
    img: Eyesome,
    role: "WordPress Web Development Internee",
    company: "Eyesome Studio Pvt. Ltd., Lahore, Remote",
    date: "Sep 2021 - Nov 2021",
    desc: "As a WordPress Web Development Intern, I assisted in designing and implementing websites using the WordPress platform. My responsibilities included customizing themes, optimizing website performance, and ensuring mobile responsiveness. I collaborated with team members to enhance user experience and troubleshoot technical issues, gaining hands-on experience in web development best practices",
    skills: [
      "WordPress CMS",
      "Elementor",
      "Ocean WP Theme",
      "JavaScript",
      "CSS",
    ],
    doc: EysomeExp,
  },
  {
    id: 1,
    img: Prodigi,
    role: "Frontend Engineer Intern",
    company: " Prodigy InfoTech, Mumbai, Remote",
    date: "15th February 2024 to 15th March, 2024",
    desc: "Developed and maintained an e-learning website, focusing on responsive design and user experience. Designed and implemented a yard management dashboard, enhancing functionality and usability. Implemented state management techniques and utilized React Router for handling dynamic data, improving application performance, and managing navigation",
    skills: ["ReactJS", "Material UI", "HTML", "CSS", "JavaScript"],
    doc: ProdigiExp,
  },
  {
    id: 1,
    img: NTUlogo,
    role: "Secured Third Position in 2024-FYP Display",
    company: "Computer Science Department, National Textile University",
    date: "Jul 2024",
    desc: "The Xplorit-Rent With Ease App is an innovative vehicle rental and lending platform that revolutionizes the rental market by addressing travelers' challenges in finding affordable and conveniently located rental vehicles and providing vehicle owners with a streamlined listing platform. It consolidates various rental services into a single, user-friendly mobile application, featuring an intuitive interface, secure user authentication, and real-time data updates. Leveraging advanced technologies like Flutter for front-end development, Firebase for robust backend capabilities, and the Google Maps API for accurate location-based services, Xplorit ensures a seamless user experience. Renters can browse diverse vehicle options, view detailed listings, and book vehicles easily, while vehicle owners benefit from a dedicated dashboard for managing listings and interactions.The app includes a secure messaging system, user reviews, and ratings to maintain transparency and trust, setting a new standard in the vehicle rental market through its comprehensive solution, transparent information, secure transactions, and user-friendly design",
    skills: [
      "Flutter",
      "ReactJS",
      "Firebase",
      "Dart",
      "Google Map API",
      "FireStore",
    ],
    doc: XploritExp,
  },
];

//Education

export const education = [
  {
    id: 0,
    img: NTUlogo,
    school: "National Textile University,Faisalabad,Pakistan",
    date: "Oct 2020 - June 2024",
    grade: "3.38 CGPA",
    desc: "I have completed Bachelor's degree in Software Engineering at National Textile University, with a CGPA of 3.38. My coursework includes Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks. I'm also an active member of the NTU Community Service Society, reflecting my commitment to both academic excellence and community engagement.",
    degree: "Bachelor of Science - BSc, Software Engineering",
  },
  {
    id: 1,
    img: Jaya,
    school: "A/Jaya Muslim Maha Vidyalaya, Kekirawa",
    date: "Apr 2015 - Aug 2017",
    grade: "Combined Maths : B, Physics : C, Chemistry : C",
    desc: "I completed my Advanced Level(A/L) education at A/Jaya Muslim Maha Vidyalaya,Kekirawa, where I studied Physical Science Stream.",
    degree: "Advanced Level (A/L), Physical Science",
  },
  {
    id: 2,
    img: Gmmv,
    school: "A/Ganewalpola Muslim Maha Vidyalaya, Kekirawa ",
    date: "Apr 2003 - Dec 2014",
    grade: "6 - A, 2 - B, 1 - C",
    desc: "I completed my Ordinary Level(O/L) education at A/Ganewalpola Muslim Maha Vidyalaya, Kekirawa, where I studied primary education to OL.",
    degree: "Ordinary Level (O/L)",
  },
];
//Project Detalis

export const projects = [
  {
    id: 0,
    title: "Agency Pro",
    date: "15th June 2021 - 20th June 2021",
    description:
      "I developed a WordPress website for a small business, focusing on enhancing online presence and customer engagement. The site features a clean, modern design with user-friendly navigation and is fully responsive for optimal viewing on all devices. Key elements include SEO optimization to improve search visibility, an integrated blog for content updates, and optional e-commerce capabilities for online sales. This project successfully supports the business by attracting more customers and providing a professional digital footprint.",
    image: Wp1,

    tags: [
      "Phlox theme",
      "Elementor Pro",
      "JavaScript",
      "CSS",
      "SEO",
      "WooCommerce Plugin",
    ],
    category: "WordPress",
    github: "https://github.com/mkabdulazees56/WordPress-Phlox-Website",
    webapp: "https://wpdesignabdulazees.netlify.app/",
  },
  {
    id: 1,
    title: "Shop Now",
    date: "15th July 2021 - 20th July 2021",
    description:
      "I developed an e-commerce WordPress website for selling clothing, shoes, and bags, designed to enhance user experience and drive sales. The site features a stylish, responsive design optimized for all devices, ensuring seamless navigation and a smooth shopping experience. Key functionalities include an integrated shopping cart, secure payment gateways, product filters, and SEO optimization to improve visibility. This project effectively supports the business by providing a professional platform for showcasing products and engaging with customers online.",
    image: Wp2,

    tags: [
      "Woostify theme",
      "Elementor Pro",
      "JavaScript",
      "CSS",
      "SEO",
      "WooCommerce Plugin",
    ],
    category: "WordPress",
    github: "https://github.com/mkabdulazees56/WordPress-eCom-Website",
    webapp: "https://ecomabdulazees.netlify.app/",
  },
  {
    id: 2,
    title: "Tutor Starter",
    date: "21st July 2021 - 30th July 2021",
    description:
      "Learning Management System (LMS) website using WordPress, Elementor, and the Tutor plugin. Similar to Udemy, this website offers a wide variety of courses for users to enroll in, as well as a platform for teachers to create and upload their own courses.One of the main features of this LMS website is the Tutor plugin, which provides a comprehensive set of tools and functionalities to manage the courses and users. It enables teachers to easily create and structure their courses, add multimedia content, and set quizzes and assignments. Additionally, students can enroll in courses, track their progress, and communicate with their instructors.",
    image: Wp3,

    tags: [
      "Woostify theme",
      "Elementor Pro",
      "JavaScript",
      "CSS",
      "SEO",
      "WooCommerce Plugin",
      "Tutor plugin",
    ],
    category: "WordPress",
    github: "https://github.com/mkabdulazees56/WordPress-LMS-Website",
    webapp: "https://lmsabdulazees.netlify.app/",
  },
  {
    id: 3,
    title: "The Portfolio",
    date: "03rd August 2021 - 10th August 2021",
    description:
      "The portfolio website I built using WordPress and Elementor is a powerful platform that allows users to showcase their projects and highlight their skills to potential employers or clients. With a sleek and modern design, the website is both user-friendly and visually appealing.Through the use of Elementor, I was able to create a dynamic page layout that is fully customizable and responsive across all devices. Users can easily create and customize their own profiles, add their projects, and categorize them for easy navigation. The website also features a powerful search function that enables users to filter projects by category, keyword, or project type.",
    image: Wp4,

    tags: ["OceanWp Theme", "Elementor Pro", "JavaScript", "CSS", "SEO"],
    category: "WordPress",
    github: "https://github.com/mkabdulazees56/WordPress-Portfolio-Website",
    webapp: "https://portfolioabdulazees.netlify.app/",
  },
  {
    id: 4,
    title: "Meme website",
    //date: "15th July 2021 - 20th July 2021",
    description:
      "The website I built is a fun and creative platform that generates random memes and quotes using JavaScript, HTML, and CSS. Users can click a button to generate a random meme or quote. The site has a simple and user-friendly interface, with an intuitive design that allows users to quickly generate and share their favorite memes and quotes on social media. The site is built to be responsive and mobile-friendly, making it accessible to users on a variety of devices. With its playful and interactive features, this website is sure to provide hours of entertainment and laughter for users of all ages.",
    image: Js1,

    tags: ["JavaScript", "CSS", "HTML"],
    category: "JavaScript",
    github: "https://github.com/mkabdulazees56/Random-meme-website",
    webapp: "https://portfolioabdulazees.netlify.app/",
  },
  {
    id: 5,
    title: "EDU Ford",
    //date: "15th July 2021 - 20th July 2021",
    description:
      "The website I built is a professional and modern website designed for a university, featuring a user-friendly interface and easy navigation. The website includes a HOME page that provides an overview of the university and its programs, an ABOUT page that describes the university's history, mission, and values, a COURSE page where students can explore the different courses offered, a BLOG page where news and events related to the university are shared, and a CONTACT page that allows visitors to get in touch with the university.",
    image: Js2,

    tags: ["JavaScript", "CSS", "HTML"],
    category: "JavaScript",
    github: "https://github.com/mkabdulazees56/Big-Unviversity-Website",
    webapp: "https://mkabdulazees56.github.io/Big-Unviversity-Website/",
  },
  {
    id: 6,
    title: "Spotify CLone",
    //date: "15th July 2021 - 20th July 2021",
    description:
      "The Spotify clone is a music streaming website that was developed using JavaScript, HTML, and CSS. With a sleek and modern design, this clone offers users an experience similar to that of the original Spotify website.",
    image: Js3,

    tags: ["JavaScript", "CSS", "HTML"],
    category: "JavaScript",
    github: "https://github.com/mkabdulazees56/Spotify-Clone",
    webapp: "https://mkabdulazees56.github.io/Spotify-Clone/",
  },
  {
    id: 7,
    title: "Weather App",
    //date: "15th July 2021 - 20th July 2021",
    description:
      "Weather app leverages a powerful weather API to provide real-time and forecasted weather information with accuracy and reliability. Whether you're planning your day or staying updated on changing weather conditions, our app offers detailed insights such as temperature, humidity, wind speed, and precipitation chances. Designed for simplicity and usability, it ensures that users can easily access essential weather data wherever they are. Stay informed and prepared with our intuitive weather app.",
    image: Js4,

    tags: ["JavaScript", "CSS", "HTML"],
    category: "JavaScript",
    github: "https://github.com/mkabdulazees56/Weather-App/",
    webapp: "https://mkabdulazees56.github.io/Weather-App/",
  },
  {
    id: 8,
    title: "MK Traders",
    //date: "15th July 2021 - 20th July 2021",
    description:
      "MK Traders, based in Sri Lanka since 2020, specializes in global trade, with a focus on importing and exporting high-quality onions and potatoes. We take pride in our commitment to excellence and look forward to continued success in the international marketplace.",
    image: Js5,

    tags: ["JavaScript", "CSS", "HTML"],
    category: "JavaScript",
    github: "https://github.com/mkabdulazees56/MK-Traders-JS-/",
    webapp: "https://mkabdulazees56.github.io/MK-Traders-JS-/",
  },
  {
    id: 9,
    title: "Javascript Games",
    //date: "15th July 2021 - 20th July 2021",
    description:
      "These games are fun and engaging projects that can help developers enhance their skills in game development and JavaScript programming. They can also be customized and expanded upon to create more complex games and applications.",
    image: Js6,

    tags: ["JavaScript", "CSS", "HTML"],
    category: "JavaScript",
    github: "https://github.com/mkabdulazees56/VannilaJS-Game-Projects",
    webapp: "https://github.com/mkabdulazees56/VannilaJS-Game-Projects",
  },
  {
    id: 10,
    title: "Vanilla JS Projects",
    //date: "15th July 2021 - 20th July 2021",
    description:
      "These projects are small-scale web applications created using vanilla JavaScript, HTML, and CSS. They are designed to teach and reinforce fundamental concepts in web development, including manipulating the DOM, event handling, data structures, and basic styling.Each project has a specific focus, such as creating interactive menus, displaying reviews, or managing a grocery list, and serves as a practical exercise for developers who want to enhance their JavaScript skills.",
    image: Js7,

    tags: ["JavaScript", "CSS", "HTML"],
    category: "JavaScript",
    github: "https://github.com/mkabdulazees56/Vanilla-JS-Projects",
    webapp: "https://github.com/mkabdulazees56/Vanilla-JS-Projects",
  },
  {
    id: 14,
    title: "Porfolio",
    //date: "15th July 2021 - 20th July 2021",
    description:
      "Showcase your work with our sleek and responsive JavaScript portfolio website. Designed to highlight your skills and projects across all devices, this platform offers an engaging user experience with smooth navigation and interactive features. Whether on desktop or mobile, visitors can explore your portfolio with ease, appreciating the aesthetics and functionality that set your work apart. Elevate your professional presence with a modern and dynamic portfolio that captures your unique talents.",
    image: Js8,

    tags: ["JavaScript", "CSS", "HTML"],
    category: "JavaScript",
    github: "https://github.com/mkabdulazees56/My-Portfoloio-Website",
    webapp: "https://mkabdulazees.netlify.app/",
  },
  //React Projects
  {
    id: 11,
    title: "Homyz",
    //date: "15th July 2021 - 20th July 2021",
    description:
      "Discover your dream home with our responsive ReactJS real estate website. Designed to provide a seamless browsing experience across all devices, our platform offers intuitive navigation and stunning visuals that showcase properties in their best light. Whether you're buying, selling, or renting, our website ensures easy access to detailed property listings, neighborhood insights, and personalized search options. With a user-friendly interface and robust performance, finding the perfect property is simpler than ever. Explore our ReactJS real estate website and embark on your next real estate journey with confidence.",
    image: Rj1,

    tags: ["JavaScript", "CSS", "HTML", "ReactJs", "Firebase"],
    category: "ReactJs",
    github: "https://github.com/mkabdulazees56/realStateWebsite-ReactJs",
    webapp: "https://realstatereact.pages.dev/",
  },
  {
    id: 12,
    title: "HooBank",
    //date: "15th July 2021 - 20th July 2021",
    description:
      "Experience seamless banking with our responsive ReactJS website, designed to cater to all your financial needs across any device. Our platform offers a user-friendly interface, ensuring effortless navigation through a comprehensive range of banking services. From secure transactions to personalized account management, our website combines functionality with an elegant design. Stay connected with real-time updates and insights, making your banking experience more efficient and enjoyable. Trust our ReactJS solution to provide a modern and responsive banking experience for everyone.",
    image: Rj2,

    tags: ["JavaScript", "CSS", "HTML", "ReactJs", "Tailwind CSS"],
    category: "ReactJs",
    github: "https://github.com/mkabdulazees56/hoobank-ReactJs",
    webapp: "https://hoobank-reactjs.pages.dev/",
  },
  {
    id: 13,
    title: "MK Traders",
    //date: "15th July 2021 - 20th July 2021",
    description:
      "Explore our ReactJS website designed for an import/export company, optimized for a seamless experience across all devices. Our responsive platform provides easy access to comprehensive services, showcasing product catalogs and logistical solutions. With an intuitive interface, users can navigate effortlessly through offerings, ensuring a smooth experience whether on desktop or mobile. Stay informed with real-time updates and enhance your global trade operations with our cutting-edge, user-friendly website.",
    image: Rj3,

    tags: ["JavaScript", "CSS", "HTML", "ReactJs", "Email js", "Tailwind CSS"],
    category: "ReactJs",
    github: "https://github.com/mkabdulazees56/MK-Traders-React-Js",
    webapp: "https://mktraders.netlify.app/",
  },
  {
    id: 15,
    title: "The News",
    //date: "15th July 2021 - 20th July 2021",
    description:
      "Stay informed with our responsive ReactJS news app, powered by a reliable news API. Designed for all devices, our platform categorizes news seamlessly, allowing users to explore the latest headlines and in-depth articles effortlessly. With a clean interface and intuitive navigation, accessing your preferred news categories is straightforward, ensuring you never miss out on important updates. Experience fast, dynamic news delivery tailored to your interests with our modern, user-friendly news app.",
    image: Rj4,

    tags: ["JavaScript", "CSS", "HTML", "ReactJs", "News Api"],
    category: "ReactJs",
    github: "https://github.com/mkabdulazees56/newsApp-React",
    webapp: "https://github.com/mkabdulazees56/newsApp-React",
  },
  {
    id: 16,
    title: "Book Shelf",
    //date: "15th July 2021 - 20th July 2021",
    description:
      "Bookshelf is a modern web application designed for book enthusiasts to effortlessly organize and manage their personal libraries. Built with the MERN stack (MongoDB, Express.js, React, Node.js) and styled using Tailwind CSS, Bookshelf offers a seamless and visually appealing user experience. Users can catalog books by entering details like title, author, and genre, and can quickly locate any book using powerful search and filter functionalities. With features such as tracking reading status, sharing reviews and ratings, and a responsive design for consistent use across devices, Bookshelf is the perfect tool to enhance and streamline your reading experience.",
    image: Mn1,

    tags: [
      "JavaScript",
      "ReactJs",
      "Email js",
      "Tailwind CSS",
      "Daisy UI",
      "MongoDB",
      "NodeJS",
      "ExpressJS",
    ],
    category: "Mern",
    github: "https://github.com/mkabdulazees56/bookStore",
    webapp: "https://github.com/mkabdulazees56/bookStore",
  },
  {
    id: 17,
    title: "MERN Athentication",
    //date: "15th July 2021 - 20th July 2021",
    description:
      "This is a full-stack web application built with the MERN (MongoDB,Express, React, Node.js) stack. It includes authentication features thatallow users to sign up, log in, and log out, and provides access to protected routes only for authenticated users.The front-end of the application is built with React and uses React Router for client-side routing. The back-end is built with Node.js and Express, and uses MongoDB as the database. Authentication is implemented using JSON Web Tokens (JWT) This application is intended as a starting point for building full-stack web applications with authentication using the MERN stack.",
    image: Mn2,

    tags: [
      "JavaScript",
      "ReactJs",
      "Redux",
      "Tailwind CSS",
      "JWT",
      "MongoDB",
      "NodeJS",
      "ExpressJS",
    ],
    category: "Mern",
    github: "https://github.com/mkabdulazees56/Mern_Auth",
    webapp: "https://github.com/mkabdulazees56/Mern_Auth",
  },

  {
    id: 18,
    title: "Word 2 PDF",
    //date: "15th July 2021 - 20th July 2021",
    description:
      "The Word to PDF Converter is a robust web application developed with the MERN stack (MongoDB, Express.js, React.js, Node.js) that efficiently transforms Word documents (.docx) into high-quality PDF files. This user-friendly tool offers a simple upload process, rapid conversion speeds, and ensures the security and privacy of your documents by automatically deleting them after conversion. With its clean and modern interface, the Word to PDF Converter provides a seamless and reliable solution for all your document conversion needs.",
    image: Mn3,

    tags: [
      "JavaScript",
      "ReactJs",
      "Tailwind CSS",
      "NodeJS",
      "ExpressJS",
    ],
    category: "Mern",
    github: "https://github.com/mkabdulazees56/Word2PDF",
    webapp: "https://github.com/mkabdulazees56/Word2PDF",
  },

  {
    id: 19,
    title: "Xplorit - Rent Lent Earn",
    //date: "15th July 2021 - 20th July 2021",
    description:
      "The Xplorit-Rent With Ease App revolutionizes the vehicle rental market by offering a seamless, user-friendly platform that addresses travelers' challenges in finding affordable and conveniently located rental vehicles while providing vehicle owners with an efficient listing service. Utilizing advanced technologies such as Flutter for the front-end, Firebase for the backend, and Google Maps API for precise location services, the app consolidates various rental services into one intuitive mobile application. It features secure user authentication, real-time data updates, a diverse vehicle browsing experience, detailed listings, easy booking, a dedicated owner dashboard for listing management, a secure messaging system, and user reviews and ratings to ensure transparency and trust, setting a new standard in the vehicle rental industry",
    image: Fl1,

    tags: [
      "Flutter",
      "ReactJs",
      "Firebase",
      "Google Map API",
      "Dart",
      "FireStore",
    ],
    category: "Flutter",
    github: "https://github.com/mkabdulazees56/Xplorit-App",
    webapp: "https://github.com/mkabdulazees56/Xplorit-App",
  },
  

  // {
  //   id: 16,
  //   title: "Book Shelf",
  //   //date: "15th July 2021 - 20th July 2021",
  //   description:
  //     "Bookshelf is a modern web application designed for book enthusiasts to effortlessly organize and manage their personal libraries. Built with the MERN stack (MongoDB, Express.js, React, Node.js) and styled using Tailwind CSS, Bookshelf offers a seamless and visually appealing user experience. Users can catalog books by entering details like title, author, and genre, and can quickly locate any book using powerful search and filter functionalities. With features such as tracking reading status, sharing reviews and ratings, and a responsive design for consistent use across devices, Bookshelf is the perfect tool to enhance and streamline your reading experience.",
  //   image:Mn1,

  //   tags: [
  //     "JavaScript",
  //     "ReactJs",
  //     "Email js",
  //     "Tailwind CSS",
  //     "Daisy UI",
  //     "MongoDB",
  //     "NodeJS",
  //     "ExpressJS",
  //   ],
  //   category: "Flutter",
  //   github: "https://github.com/mkabdulazees56/bookStore",
  //   webapp: "https://github.com/mkabdulazees56/bookStore",
  // },

  // {
  //   id: 11,
  //   title: "Podstream",
  //   date: "Apr 2023 - May 2023",
  //   description:
  //     "Developed a full-stack web application that allows users to search for, play, and pause their favorite podcasts on demand and create podcasts. Implemented user authentication using Google Auth and Jwt Auth, made responsive user interface with React JS that provides users with a seamless experience across all devices. Practiced agile methodologies to optimize team efficiency and communication.",
  //   image:
  //     "https://user-images.githubusercontent.com/64485885/234602896-a1bd8bcc-b72b-4821-83d6-8ad885bf435e.png",
  //   tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Redux"],
  //   category: "web app",
  //   github: "https://github.com/rishavchanda/Podstream",
  //   webapp: "https://podstream.netlify.app/",
  //   member: [
  //     {
  //       name: "Rishav Chanda",
  //       img: "https://avatars.githubusercontent.com/u/64485885?v=4",
  //       linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
  //       github: "https://github.com/rishavchanda/",
  //     },
  //     {
  //       name: "Upasana Chaudhuri",
  //       img: "https://avatars.githubusercontent.com/u/100614635?v=4",
  //       linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
  //       github: "https://github.com/upasana0710",
  //     },
  //   ],
  // },
];
